module.exports = __webpack_public_path__ + "static/media/2젠더-평등한나라.4d80efcd.mp3";